import Router from 'next/router';
import NProgress from 'nprogress';
import React from 'react';

const useProgressBar = () => {
	Router.events.on('routeChangeStart', () => {
		NProgress.start();
	});

	Router.events.on('routeChangeComplete', () => {
		NProgress.done();
	});

	Router.events.on('routeChangeError', () => NProgress.done());

	React.useEffect(
		() =>
			// Clean up NProgress on component unmount
			() => {
				NProgress.remove();
			},
		[],
	);

	return null;
};

export default useProgressBar;
